exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-form-item[data-v-790d3a66] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: 0;\n}\n.full-form-item[data-v-790d3a66] .ant-form-item-control-wrapper {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1 1;\n      -ms-flex: 1 1;\n          flex: 1 1;\n  display: inline-block;\n}\n.j-inline-form[data-v-790d3a66] .ant-form-item {\n  margin-bottom: 12px;\n}\n.j-inline-form[data-v-790d3a66] .ant-form-item-label {\n  line-height: 32px;\n  width: auto;\n}\n.j-inline-form[data-v-790d3a66] .ant-form-item-control {\n  height: 32px;\n  line-height: 32px;\n}\n", ""]);

// exports
